module.exports = __webpack_public_path__ + "static/media/chill.5a6feb38.svg";